//
//
//
//
//
//

export default {
  name: 'Spinner',
  props: {
    inline: {
      type: Boolean,
      default: () => false,
    },
    componentSized: {
      type: Boolean,
      default: () => true,
    },
    sizeClass: {
      type: String,
      default: () => 'fa-5x',
    },
    additionalClass: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    divClass() {
      return {
        'display-inline': this.inline,
        'component-sized': this.componentSized,
      };
    },
    spinnerClass() {
      const spinnerClasses = [
        'fas',
        'fa-spinner',
        'fa-spin',
      ];
      if (this.sizeClass) {
        spinnerClasses.push(this.sizeClass);
      }
      if (this.additionalClass) {
        spinnerClasses.push(this.additionalClass);
      }
      return spinnerClasses;
    },
  },
};
